// extracted by mini-css-extract-plugin
module.exports = {"youWillAlsoLike":"YouWillAlsoLike-module__youWillAlsoLike___2ggo9","carousel":"YouWillAlsoLike-module__carousel___2U60e"};